import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesCoupons } from "../../constants";
import { ChangeCouponStatusParams } from "./changeCouponStatus.types";

export const requestChangeCouponStatus = async ({
  couponId,
  action
}: ChangeCouponStatusParams): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesCoupons.Coupons, couponId, action)
  );
};
